import FullVideo from "./full-video.component";

export default FullVideo;
